'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@extern/ui/button';
import { useAuthEvents } from '@/app/(auth)/_hooks/use-auth-events';
import { useLastAuthenticationStrategy } from '@/app/(auth)/_hooks/use-last-authentication-strategy';
import { AuthLastUsedButtonWrap } from '@/app/(auth)/_partials/auth-last-used-badge';
import { useSignIn } from '../_hooks/use-sign-in';
import { useSignInFlowStore } from '../_hooks/use-sign-in-flow-store';
export function SignInChooseStrategyExperiment() {
  const $ = _c(28);
  const {
    onPrepareEmailCodeFirstFactor,
    signIn,
    fetchStatus
  } = useSignIn();
  const {
    trackSignInStrategySelected,
    trackSignInEmailReturnClicked
  } = useAuthEvents();
  const lastAuthenticationStrategy = useLastAuthenticationStrategy();
  const identifier = useSignInFlowStore(_temp);
  const experimentIdentifier = useSignInFlowStore(_temp2);
  const onChange = useSignInFlowStore(_temp3);
  const resolvedIdentifier = identifier || experimentIdentifier;
  let t0;
  if ($[0] !== signIn.supportedFirstFactors) {
    t0 = signIn.supportedFirstFactors?.some(_temp4) ?? false;
    $[0] = signIn.supportedFirstFactors;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasEmailCodeFromFactors = t0;
  let t1;
  if ($[2] !== hasEmailCodeFromFactors || $[3] !== resolvedIdentifier) {
    t1 = hasEmailCodeFromFactors || resolvedIdentifier.includes("@");
    $[2] = hasEmailCodeFromFactors;
    $[3] = resolvedIdentifier;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const hasEmailCode = t1;
  let t2;
  if ($[5] !== signIn.supportedFirstFactors) {
    t2 = signIn.supportedFirstFactors?.some(_temp5) ?? false;
    $[5] = signIn.supportedFirstFactors;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const hasPassword = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-2"><h1 className="font-semibold text-lg">Sign in with Email Code</h1><p className="text-role-on-surface-variant text-sm">Choose how you want to continue signing in.</p></div>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== fetchStatus || $[9] !== hasEmailCode || $[10] !== lastAuthenticationStrategy || $[11] !== onPrepareEmailCodeFirstFactor || $[12] !== trackSignInStrategySelected) {
    t4 = hasEmailCode ? <AuthLastUsedButtonWrap matchStrategy="email_code" strategy={lastAuthenticationStrategy}><Button appearance="filled" className="w-full" color="info" disabled={fetchStatus === "fetching"} isLoading={fetchStatus === "fetching"} onClick={() => {
        trackSignInStrategySelected("email_code");
        onPrepareEmailCodeFirstFactor().catch(_temp6);
      }} type="button">Email code</Button></AuthLastUsedButtonWrap> : null;
    $[8] = fetchStatus;
    $[9] = hasEmailCode;
    $[10] = lastAuthenticationStrategy;
    $[11] = onPrepareEmailCodeFirstFactor;
    $[12] = trackSignInStrategySelected;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== hasPassword || $[15] !== lastAuthenticationStrategy || $[16] !== onChange || $[17] !== trackSignInStrategySelected) {
    t5 = hasPassword ? <AuthLastUsedButtonWrap matchStrategy="password" strategy={lastAuthenticationStrategy}><Button appearance="outlined" className="w-full" color="info" onClick={() => {
        trackSignInStrategySelected("password");
        onChange({
          firstFactorStrategy: "password",
          isFormVisible: true,
          step: "start"
        });
      }} type="button">Password</Button></AuthLastUsedButtonWrap> : null;
    $[14] = hasPassword;
    $[15] = lastAuthenticationStrategy;
    $[16] = onChange;
    $[17] = trackSignInStrategySelected;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <div className="flex flex-col gap-3">{t4}{t5}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== onChange || $[23] !== trackSignInEmailReturnClicked) {
    t7 = <Button appearance="outlined" color="info" onClick={() => {
      trackSignInEmailReturnClicked("choose_strategy", "start_email_form");
      onChange({
        isFormVisible: true,
        step: "start"
      });
    }} type="button">Return</Button>;
    $[22] = onChange;
    $[23] = trackSignInEmailReturnClicked;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t6 || $[26] !== t7) {
    t8 = <div className="flex w-full max-w-full flex-col gap-6 overflow-clip rounded-3xl border border-role-outline-subtle bg-white p-6 sm:w-[358px]">{t3}{t6}{t7}</div>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}
function _temp6() {}
function _temp5(factor_0) {
  return factor_0.strategy === "password";
}
function _temp4(factor) {
  return factor.strategy === "email_code";
}
function _temp3(s_1) {
  return s_1.onChange;
}
function _temp2(s_0) {
  return s_0.experimentIdentifier;
}
function _temp(s) {
  return s.identifier;
}